<template>
  <div :style="{width: mode === 'mini' ? '100vw': '100%'}">
    <div class="player-basic" v-show="mode === 'basic'">
      <vue-plyr :options="playerOptions" ref="plyr" id="player"
                class="player"
                @timeupdate="videoTimeUpdated" @playing="nowPlaying" @ready="playerReady" @pause="updatePaused"
                :emit="['ready','timeupdate','playing']">

<!--        <audio :src="require('../assets/a.mp3')" format="audio/mp3"></audio>-->
<!--              <audio :src="audioSrc" format="audio/mp3" @ended="playEnd"></audio>-->
            <audio :src="audioSrc" format="audio/mp3"></audio>
      </vue-plyr>

      <div class="button-group">
        <div class="repeat">
          <img v-if="!isRepeat" src="/assets/player/repeat.png" width="17" height="20" @click="repeatClickEvent" />
          <img v-if="isRepeat" src="/assets/player/repeat-active.png" width="17" height="20" @click="repeatClickEvent" />
        </div>
        <div class="backward">
          <img src="/assets/player/backward.png" width="30" height="16" @click="backwardClickEvent" />
        </div>
        <div v-if="!isPlaying" class="play" @click="playClickEvent">
          <img src="/assets/player/play.png" height="33" />
        </div>
        <div v-else class="pause" @click="playClickEvent">
          <img src="/assets/player/pause.png" height="33" />
        </div>
        <div class="forward">
          <img src="/assets/player/forward.png" width="30" height="16" @click="forkwardClickEvent"/>
        </div>
        <div class="speed" @click="changeSpeed">
          <img v-if="speed === 0.5" src="/assets/player/0.5x.png" width="18" height="20" />
          <img v-if="speed === 1" src="/assets/player/1x.png" width="18" height="20" />
          <img v-if="speed === 1.5" src="/assets/player/1.5x.png" width="18" height="20" />
          <img v-if="speed === 2" src="/assets/player/2x.png" width="18" height="20" />
        </div>
      </div>
    </div>
    <template v-if="mode === 'mini'">
      <div :class="{'mini-player container':true, 'mini-fixed':miniMode==='fixed'}"
           :style="{bottom: $store.state.miniPlayerBottom}"
      >
        <template v-if="type === 'new'">
          <div @click="playClickEvent">
            <img v-if="isPlaying" src="/assets/common/mini-player/pause.png" width="15" />
            <img v-else src="/assets/new/ic_play3.png" width="15" />
          </div>
          <div class="current-time" align="right">
            {{  this.currentTime }}
          </div>
          <ion-range ref="ion_range" @mousedown="onSeekFocus" @mouseup="onSeek" class="range">
          </ion-range>
          <img src="/assets/new/ic_volume.png" height="20" @click="onVolume" @focusout="onVolume"/>
          <div v-show="showVolume" class="volume-wrap" @blur="onVolume">
            <ion-range ref="ion_range_volume" @ionChange="onVolumeChange" class="range-volume">
            </ion-range>
          </div>
        </template>
        <template v-else>
            <div class="title" @click="$emit('basicMode')">
              <div class="word_comma_1">{{ courseInfo.course_name }}</div>
              <div v-if="courseInfo.lecture_div === '30'">{{ courseInfo.my_category_name + "(" + courseInfo.school_grade_name + ")" }}</div>
              <div v-else-if="courseInfo.lecture_div === '20'">{{ courseInfo.plan_subject_name + "(" + courseInfo.school_grade_name + ")" }}</div>
              <div v-else>{{ courseInfo.subject_name + "(" + courseInfo.school_grade_name + ")" }}</div>
            </div>
            <div class="icon-group">
              <img v-if="!isPlaying" src="/assets/common/mini-player/play.png" height="36" @click="playClickEvent" />
              <img v-else src="/assets/common/mini-player/pause.png" height="36" @click="playClickEvent" />
              <img src="/assets/common/mini-player/more.png" width="15" height="15" @click="$emit('basicMode')" />
            </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import * as ajax from "../utils/ajax";
import {EventBus} from "./AudioPlayerNew";

const BACKWARD_SECOND_TIME = 30;
const FORWARD_SECOND_TIME = 30;
export default {
  name: "BasicPlayer",
  props:{
    type:{
      type: String,
      default: 'new',
    },
    audioSrc:{
      type: String,
      default: '../assets/a.mp3',
    },
    mode:{
      type:String,
      default:"basic"
    },
    miniMode:{
      type: String,
      default:'fixed',
    },
    isRole:{
      type:Boolean,
      default:false,
    },
    courseInfo:{
      type:Object,
    }
  },
  watch:{
    mode(){
      setTimeout(()=>{
        if(this.mode == 'mini'){
          this.$refs.ion_range_volume.value = this.player().volume * 100;
        }
      }, 200);
    },
    isPlaying(){
      if(this.isPlaying){
        this.start_timer();
      }else{
        this.stop_timer();
      }
    },
    audioSrc(){
      this.reset_timer();
    },
    '$store.state.basicPlayerVisibility' (){
      if(this.$store.state.basicPlayerVisibility)
      setTimeout(this.reset_timer(),1000);
    },
  },
  data(){
    return {
      showVolume:false,
      currentTime:'',
      isPlaying: false,
      isRepeat: false,
      isEnded: false,
      listenEnd:false,
      speed: 1,
      is70: false,             // 70% 여부

      focus:false,

      playedTime:0,
      timer:{},
    }
  },
  computed:{
    playerOptions() {
      const options = {
        controls: ['progress','current-time','duration'],
        storage: { enabled: true, key: 'plyr' }
        //autoplay: true
      };
      return options
    },


  },
  methods:{
    onSeekFocus(){
      this.focus = true;
    },

    currentTimeFormatter(){
      let hour = parseInt(this.player().currentTime / 3600);
      hour = hour < 10 ? '0'+ hour : hour;

      let min = parseInt(this.player().currentTime / 60);
      min = min < 10 ? '0'+ min : min;

      let sec =  parseInt(this.player().currentTime % 60);
      sec = sec < 10 ? '0'+ sec : sec;

      return  hour + ':' + min + ':' + sec;
    },
    onSeek(){
      console.log("on seek"+this.$refs.ion_range.value)
      this.focus = false;
      this.showVolume = false;
      this.player().currentTime = this.player().duration * this.$refs.ion_range.value / 100;
    },
    onVolume(){
      this.showVolume = !this.showVolume;
    },
    onVolumeChange(){
      this.player().volume = this.$refs.ion_range_volume.value / 100;
    },
    player() {
      return this.$refs.plyr.player;
    },
    reset_timer(){
      this.playedTime = 0;
    },
    start_timer(){
      this.timer = setInterval(()=>{
        this.playedTime += (1 * this.speed);
        // console.log(this.playedTime);
      },1000);
    },
    stop_timer(){
       clearInterval(this.timer);
    },

    videoTimeUpdated(event) {
      if (!this.focus && this.$refs.ion_range != undefined)
        this.$refs.ion_range.value = this.player().currentTime / this.player().duration * 100;
      this.currentTime = this.currentTimeFormatter();

      const player = this.player();
      const currentTime = player.currentTime;
      const duration = player.duration;

      // console.log('-----------------current time:', currentTime);
      // console.log('-----------------total time:', duration);
      // console.log('-----------------current play pro:', currentTime / duration * 100);
      // console.log("------------------isEnded;", this.isEnded);
      // console.log("------------------isEnded;", duration - currentTime);
      if (!this.isEnded && (duration - currentTime <= 0.5))
      {
        console.log("------------------wellDone;")
        this.isEnded = true;
        this.$emit('ended');
      }
      if (duration - currentTime > 0.5) {
        this.isEnded = false
      }
      // 95% 이상 청쥐하면 전체듣기로 처리(course 듣기시간계수에 이용)
      if (!this.listenEnd && (this.playedTime / duration * 100 > 95)) {
        this.listenEnd = true;
        this.$emit('listenEnd');
      }

      if (this.playedTime / duration * 100 < 95) {
        this.listenEnd = false;
      }

      // 듣기권한이 없는 경우 2분이 되면 playstop시키고 이용권 구매 안내 팝업
      // if (currentTime > 120 && this.isRole === false) {
      if (currentTime > 12000 && this.isRole === false) {
        player.pause();
        this.isPlaying = false;
        this.$emit("limit")
      }


      if (this.is70)
        return;



      // 70% 이상 청쥐하면 완강으로 처리
      if (this.playedTime / duration * 100 > 70) {
        this.is70 = true;
        this.$emit('is70');
      }

    },

    nowPlaying(event) {
      // ion_range.value = this.player().currentTime;
    },


    playerReady () {
      //this.player.currentTime = 95
      // console.log('player ready')
    },
    updatePaused(event) {
      console.log('updatePaused :' + event)
    },
    playEnd() {
      this.$emit('ended');
    },
    repeatClickEvent() {
      this.isRepeat = !this.isRepeat;

      const player = this.player();
      player.loop = this.isRepeat;
    },
    // 뒤로 30초
    backwardClickEvent() {
      this.player().rewind(BACKWARD_SECOND_TIME);
    },
    playClickEvent() {
      this.showVolume = false;

      if (this.isPlaying) {
        this.player().pause();
        this.isPlaying = false;

      } else {
        this.player().play();
        this.player().speed = this.speed;
        this.isPlaying = true;
      }
      EventBus.$emit('playListEvent', this.isPlaying)
    },
    initPlay(){
      console.log('-----------------init play----------------')
      this.player().currentTime = 0;
      this.player().play();
      this.player().speed = this.speed;
      this.isPlaying = true;
      this.isRepeat =  false;
      this.is70 = false;
      this.isEnded = false;
    },
    // 앞으로 30초
    forkwardClickEvent() {
      this.player().forward(FORWARD_SECOND_TIME);
    },
    changeSpeed() {
      switch (this.speed) {
        case 0.5:
          this.speed = 1;
          break;
        case 1:
          this.speed = 1.5;
          break;
        case 1.5:
          this.speed = 2;
          break;
        case 2:
          this.speed = 0.5;
          break;
      }

      const player = this.player();
      player.speed = this.speed;
    },
  },
  mounted() {
    this.currentTime = this.currentTimeFormatter();

    setTimeout(()=>{
      if(this.mode == 'mini'){
        this.$refs.ion_range_volume.value = this.player().volume * 100;
      }
    }, 200);
  }
}
</script>
<style lang="css">
@import '../css/plyr.css';
</style>

<style scoped lang="scss">
div.player-basic {
  margin-top: 50px;

div.time {
  margin-top: 6px;
  display: flex;
  justify-content: space-between;
  font-size: $font-base12;
  color: #1e212f;

div.total-time {
  color: $font-third-color;
}
}
div.button-group {
  clear: both;
  margin-top: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
}

div.mini-fixed{
  left: 50%;
  transform: translate(-50%, 0);
  position: fixed;
  bottom: 90px;
  z-index: 110;
}

div.mini-player {

  width: 100%;
  height: 50px;
  background: #353A3F;
  padding:0.2em $default-margin-right;

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.player{
  flex:1;
  transform: translate(0, -5px);
}

.range{
  --bar-background: white!important;
  --knob-size:0;
  --bar-height: 3px;
}

.range-volume{
  --bar-background: white!important;
  --knob-size:6px;
  padding: 0 0.5em;
}
.current-time{
  line-height: 1em;
  width: 5em!important;
  font-size: $font-base15;
  color: white;
  margin-left: 0.5em;
}
.volume-wrap{
  position: absolute;
  top: -2.5em;
  right: 0.2em;
  width:6em;
  height: 2.3em;
  background: #353A3F;
  border-radius: 0.2em;
}

div.icon-group {
  width: 95px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

div.title {
  width: 100%;
  div:first-child {
    font-size: $font-base14;
    color: white;
  }
  div:nth-child(2) {
    font-size: $font-base10;
    color: $primary-color;
  }
}
</style>